import React from "react";

const Footer = () => (
  <footer className="text-center text-xs py-4 border-t border-gray-300 dark:border-gray-700 bg-gray-100 dark:bg-[#0f172a]">
    © 2025 TwoFleet Technologies. All rights reserved.
  </footer>
);

export default Footer;